import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { InvestmentGroup } from '../../../Models/Models/PortfolioAnalysis/Investment/InvestmentGroup';
import { IJsonDate } from '../../../System/IJsonDate';
import { AssetClassType } from '../../../Constants/Enums/Domain/Instrument/AssetClassType';

declare var IS_RUNNING_IN_APP_POOL;

export class ProductModelPortfolioInvestmentClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(modelFundInstrumentCode: Array<string>, asAt: IJsonDate, assetClass: AssetClassType): Promise<Array<InvestmentGroup>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/PortfolioAnalysis/Investment/ProductModelPortfolioInvestment/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { modelFundInstrumentCode: modelFundInstrumentCode, asAt: asAt, assetClass: assetClass }

    return AjaxWrapper.get<Array<InvestmentGroup>, any>(url, data);
  }
}

